<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>

      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template #opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="command">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ ...opt, row }"
                :divided="opt.divided"
                :disabled="
                  opt.status && opt.status.length
                    ? !opt.status.includes(row.pdProcessDictStatus)
                    : false
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template #empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    command({ menuType, row }) {
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('edit', { type: menuType, row })
          break
        case 'delete':
          this.del(row)
          break
      }
    },
    async del({ inspectionAqlCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return

      if (this.loadingOpen()) return

      const res = await this.$api
        .mrpInspectionAqlDelApi({ inspectionAqlCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })

      this.$emit('reload')
    },
  },
}
</script>
